<script setup lang="ts">

import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useSectionTutorLegal } from '../../model/legal/section-tutor-legal.hook'
import TutorLegalPersonalInfo from './TutorLegalPersonalInfo.vue'
import TutorLegalDocuments from './TutorLegalDocuments.vue'
import TutorLegalBilling from './TutorLegalBilling.vue'

defineOptions({
  name: 'SectionTutorLegal',
})

const {
  save,
} = useSectionTutorLegal()
</script>

<template>
  <CardAdmin
    title="Legal info"
    fullwidth
    class="tutor-legal"
  >
    <template #header>
      <BtnPrimary
        text="Save"
        color="emerald"
        @click="save"
      />
    </template>

    <div class="tutor-legal__body">
      <TutorLegalPersonalInfo />

      <div class="tutor-legal__divider" />

      <TutorLegalDocuments />

      <div class="tutor-legal__divider" />

      <TutorLegalBilling />
    </div>
  </CardAdmin>
</template>

<style lang="scss" scoped src="./SectionTutorLegal.scss" />
